module.exports = __webpack_public_path__ + "assets/img/icon-dz.362ed8aa.png";